<template>
  <h1>Shopper Home Page</h1>
</template>

<script setup lang="ts"></script>
